import { bool, number, oneOf, oneOfType, string } from "prop-types";

/*
    If you change the structure in this file, you must check:
        CustomData.js and ExampleData.js

    (This will not break any component that is using
        CustomData if you just add keys)
*/

/* CustomData PropType */

export const currencies = ["ARS", "USD"];
export const textTypes = ["STRING", "MONEY", "NUMBER", "PERCENTAGE", "DATE", "I18N", ...currencies];

export const customDataPropType = {
    titleText: oneOfType([string, number]),
    titleTextType: oneOf(textTypes),
    titleClass: string,

    valueText: oneOfType([string, number]),
    valueTextType: oneOf(textTypes),
    valueClass: string,

    keepSpaceIfNoValue: bool,
    dataClass: string,
    hideTitleDesktop: bool,
    withPrintFormat: bool,
};

export const defaultCustomDataPropType = {
    titleText: "",
    titleTextType: "STRING",
    titleClass: "",

    valueText: "",
    valueTextType: "STRING",
    valueClass: "",

    keepSpaceIfNoValue: true,
    dataClass: "",
    hideTitleDesktop: false,
    withPrintFormat: false,
};
